// ============================================================================
// GERMAN TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Faszinierende Fakten über die Bibel

export const bibleFacts = [
  {
    category: "struktur",
    text: "Die Bibel enthält 66 Bücher, die von über 40 verschiedenen Autoren über einen Zeitraum von etwa 1500 Jahren geschrieben wurden",
    source: "Kanonische Bibelstruktur"
  },
  {
    category: "umfang",
    text: "Die Bibel enthält 31.173 Verse, 1.189 Kapitel und etwa 783.137 Wörter in ihrer Originalversion",
    source: "Biblische Textanalyse"
  },
  {
    category: "übersetzung",
    text: "Die Bibel wurde vollständig oder teilweise in über 3.000 Sprachen übersetzt und ist damit das meistübersetzte Buch der Welt",
    source: "Weltbund der Bibelgesellschaften"
  },
  {
    category: "vers",
    text: "Der kürzeste Vers der Bibel ist 'Jesus weinte' (Johannes 11:35), während der längste Ester 8:9 ist",
    source: "Biblische Textanalyse"
  },
  {
    category: "popularität",
    text: "Die Bibel ist das meistverkaufte Buch aller Zeiten mit über 5 Milliarden verteilten Exemplaren",
    source: "Verlagsaufzeichnungen"
  },
  {
    category: "geschichte",
    text: "Die 1947 entdeckten Schriftrollen vom Toten Meer enthalten biblische Manuskripte, die über 2.000 Jahre alt sind",
    source: "Biblische Archäologie"
  },
  {
    category: "mitte",
    text: "Das zentrale Kapitel der Bibel ist Psalm 118, und der zentrale Vers ist Psalm 118:8",
    source: "Numerische Bibelstruktur"
  }
];

export default bibleFacts;
